import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import { apiMethods } from '../api';
import { getValidatedPhoneNumber } from '../components/voip/utils/get-validated-phone-number';
import { WidgetContext } from './widget-context';
export const WidgetContextProvider = ({ platform, open, onBack, onClose, hasFeature, children, startView, nodeEnv, setBackground, trackInAnalytics, phoneNumber, immediatelyStartCall, isWebview, theme, goNext, isPreAuth, onOpenPreAuthChat, collapsedDisable, useWidgetInNewclickHostUi, }) => {
    const { getPhoneInformationApiMethod } = apiMethods;
    const [displayPanel, setDisplayPanel] = useState(startView);
    const [needImmediatelyStartCall, setNeedImmediatelyStartCall] = useState(immediatelyStartCall);
    const [openedPopup, setOpenedPopup] = useState(false);
    const [canOpenedPopup, setCanOpenedPopup] = useState(false);
    const [collapsedCall, setCollapsedCall] = useState(false);
    const onBackRef = useRef(onBack);
    useEffect(() => {
        sessionStorage.setItem('collapsedCall', collapsedCall.toString());
    }, [collapsedCall]);
    useEffect(() => {
        if (open) {
            setDisplayPanel(startView);
            setNeedImmediatelyStartCall(immediatelyStartCall);
        }
    }, [open, startView, immediatelyStartCall]);
    useEffect(() => {
        window.toggleCollapsedRef = (val) => setCollapsedCall(val);
    }, []);
    const context = useMemo(() => ({
        platform,
        open,
        onBack: onBackRef.current,
        onClose,
        getPhoneInformationApiMethod,
        hasFeature,
        startView,
        displayPanel,
        setDisplayPanel,
        nodeEnv,
        setBackground,
        trackInAnalytics,
        phoneNumber: getValidatedPhoneNumber(phoneNumber),
        needImmediatelyStartCall,
        setImmediatelyStartCall: setNeedImmediatelyStartCall,
        isWebview,
        theme,
        goNext,
        openedPopup,
        setOpenedPopup,
        canOpenedPopup,
        setCanOpenedPopup,
        collapsedCall,
        setCollapsedCall,
        isPreAuth,
        onOpenPreAuthChat,
        collapsedDisable,
        cssVarsPrefix: useWidgetInNewclickHostUi ? 'h' : '',
    }), [
        platform,
        open,
        onClose,
        getPhoneInformationApiMethod,
        hasFeature,
        startView,
        displayPanel,
        nodeEnv,
        setBackground,
        trackInAnalytics,
        phoneNumber,
        needImmediatelyStartCall,
        isWebview,
        theme,
        goNext,
        openedPopup,
        setOpenedPopup,
        canOpenedPopup,
        collapsedCall,
        setCollapsedCall,
        isPreAuth,
        onOpenPreAuthChat,
        collapsedDisable,
        useWidgetInNewclickHostUi,
    ]);
    return _jsx(WidgetContext.Provider, { value: context, children: children });
};
